import React from "react";
import { ImageIcon, PlayCircle } from "lucide-react";

/**
 * Tasteful placeholder for product images / videos that the client will provide later.
 * If `image` prop is supplied, renders the actual image instead of the placeholder frame.
 */
export const Placeholder = ({
  label = "Product visual coming soon",
  aspect = "aspect-video",
  type = "image",
  className = "",
  testId,
  image,
  imageAlt,
  objectFit = "cover",
}) => {
  if (image) {
    return (
      <div
        data-testid={testId}
        className={`${aspect} w-full rounded-2xl overflow-hidden bg-[#FFF5E1] ${className}`}
      >
        <img
          src={image}
          alt={imageAlt || label}
          className={`w-full h-full ${objectFit === "contain" ? "object-contain" : "object-cover"}`}
          loading="lazy"
        />
      </div>
    );
  }

  const Icon = type === "video" ? PlayCircle : ImageIcon;
  return (
    <div
      data-testid={testId}
      className={`${aspect} w-full rounded-2xl border-2 border-dashed border-[#F39C12]/45 bg-[#FFF5E1] flex flex-col items-center justify-center text-center px-6 py-8 ${className}`}
    >
      <div className="rounded-full bg-white p-4 shadow-sm mb-4">
        <Icon className="w-7 h-7 text-[#F39C12]" strokeWidth={1.6} />
      </div>
      <p className="font-display text-base sm:text-lg text-[#2C3E50] font-semibold">
        {label}
      </p>
      <p className="text-xs sm:text-sm text-[#7F8C8D] mt-1 max-w-xs">
        Real, in-kitchen visuals will be added by the team.
      </p>
    </div>
  );
};

export default Placeholder;
